import { BaseDataService, BaseUpdateComponent, ErrorHandlerService, ModalService, NotificationService, UserService } from "yt-ng-framework";
import { EOtpremnicaStavkaDodatniAtribut } from "./eotpremnica-stavka-dodatni-atribut";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { EOtpremnicaService } from "./eotpremnica-service";

@Component({
    selector: 'yt-eotpremnica-stavka-dodatni-atribut-update',
    templateUrl: './eotpremnica-stavka-dodatni-atribut-update.component.html'
})
export class EOtpremnicaStavkaDodatniAtributUpdateComponent
    extends BaseUpdateComponent<EOtpremnicaStavkaDodatniAtribut>
    implements OnInit, OnDestroy {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected otpremnicaService: EOtpremnicaService,
        protected userService: UserService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modalService: ModalService,
        protected errorService: ErrorHandlerService

    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);

    }

    izlazna: boolean = false;
    locked: boolean = false;

    ngOnInit() {
        super.ngOnInit();

        this.IDProcessed
        .subscribe((value) => {
            if (this.Parameters && this.Parameters.get(0))
                this.locked = Boolean(this.Parameters.get(0).get(0).Value);

            this.izlazna = this.modelData.MainList.FormControlDataName === "eotpremnice/izeotpremnicastavkadodatniatribut";

            if (!this.izlazna) {
                this.baseFormGroup.disable();
                this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
            }
        })
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}